import { AlertCircle, CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";

type AlertMessageProps = {
  message: string | null;
  type: "error" | "success";
  className?: string;
};

export function AlertMessage({ message, type, className }: AlertMessageProps) {
  if (!message) return null;

  const isError = type === "error";

  return (
    <div
      className={cn(
        "mb-6 rounded-md border p-4 text-sm flex",
        isError
          ? "border-red-200 bg-red-50 text-red-700"
          : "border-green-200 bg-green-50 text-green-700",
        className
      )}
    >
      <div className="flex items-center">
        {isError ? (
          <AlertCircle className="mr-2 h-4 w-4" />
        ) : (
          <CheckCircle className="mr-2 h-4 w-4" />
        )}
        {message}
      </div>
    </div>
  );
}
